module.exports = __webpack_public_path__ + "static/media/almost_a_lie.0be85b70.jpg";